var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('b-link',{attrs:{"href":"/register/seller"}},[_c('b-img',{staticClass:"w-100",attrs:{"src":_vm.$root.MEDIAPATH+'banners/Strip-Call-Out-PDP-Banner-01.png'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }